import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { SalesQuotationFileImportHelperContainerModel } from '../../../../../../models/aggregates/erp/sales-quotation-file-import/index';

@Injectable({
  providedIn: 'root'
})
export class SalesQuotationFileImportHelperService extends BaseApiTemplateService<SalesQuotationFileImportHelperContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-sales-quotation/import-file-hdr/helper/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-sales-quotation/import-file-hdr/helper/backoffice-ep';
    this.httpClient = http;
  }
}